// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useRef, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth} from '../core/Auth'
import {affiliateRegister, searchYad2Agents, getUserByToken, Yad2AgentRow, trackReferralClick, googleSignIn, facebookSignIn} from '../core/_requests'
import {trackRegistration} from '../../../lib/metaPixel'
import {TurnstileWidget, TURNSTILE_ENABLED} from './TurnstileWidget'

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '266985490329-3imd6ndlah8s68ko95eucubleneg6goi.apps.googleusercontent.com'
// Same app as the login page's Facebook button; the button only shows when it's set.
// "Login with Facebook" is switched OFF for now (doesn't work yet). To turn it back on:
// const FB_APP_ID = process.env.REACT_APP_FB_APP_ID || ''
const FB_APP_ID = ''

// Read a query-string param (the affiliate referral code rides in ?aff=).
const getParam = (key: string): string => {
  try {
    return new URLSearchParams(window.location.search).get(key) || ''
  } catch (_) {
    return ''
  }
}

// Israeli mobile numbers are 10 digits starting 05X. Accepts what people actually type —
// dashes, spaces, dots, a +972 / 972 prefix — and returns the canonical 05XXXXXXXX form,
// or null if it isn't a mobile number. Landlines (02/03/04/08/09) and 07X service numbers
// are deliberately rejected: they can't receive the SMS the account depends on.
export function normaliseIlMobile(raw: string): string | null {
  const s = String(raw || '').trim()
  // Letters in the field mean a typo, not a number worth quietly salvaging. Stripping
  // non-digits alone would have accepted "בדיקה0544759123" as a valid number — which is
  // exactly how junk like that reached a real account record.
  if (!/^\+?[\d\s().-]+$/.test(s)) return null
  const digits = s.replace(/\D/g, '')
  const local = digits.startsWith('972') ? '0' + digits.slice(3) : digits
  return /^05\d{8}$/.test(local) ? local : null
}

export function Yad2Register(props: any = {}) {
  // withYad2 === false ⇒ a plain affiliate signup with no yad2 agent picker / import.
  const withYad2 = props.withYad2 !== false
  const {saveAuth, setCurrentUser} = useAuth()

  const [form, setForm] = useState({yourname: '', phone: '', email: '', password: ''})
  const [aff, setAff] = useState('')

  // yad2 agent search/picker
  const [agentQuery, setAgentQuery] = useState('')
  const [results, setResults] = useState<Yad2AgentRow[]>([])
  const [searching, setSearching] = useState(false)
  const [showResults, setShowResults] = useState(false)
  const [agent, setAgent] = useState<Yad2AgentRow | null>(null)
  const searchTimer = useRef<any>(null)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [turnstileToken, setTurnstileToken] = useState('')

  useEffect(() => {
    // Capture the affiliate code from the URL (fallback to a previously stored one).
    const a = getParam('aff') || localStorage.getItem('aff') || ''
    if (a) {
      setAff(a)
      try {
        localStorage.setItem('aff', a)
      } catch (_) {}
      // Track the click once per browser per code (a fresh visit from the URL param counts;
      // refreshes/return visits don't re-inflate the count).
      try {
        const cameFromLink = getParam('aff')
        const key = `aff_click_tracked_${a}`
        if (cameFromLink && !localStorage.getItem(key)) {
          localStorage.setItem(key, '1')
          trackReferralClick(a).catch(() => {})
        }
      } catch (_) {}
    }
  }, [])

  // Google sign-up. After auth the user is logged in; if name/phone are missing the
  // global profile gate blocks the app until they're provided, then onboarding starts.
  const finishGoogleLogin = async (api_token: string) => {
    saveAuth({api_token})
    const {data: user} = await getUserByToken(api_token)
    trackRegistration(user)
    setCurrentUser(user)
  }
  const handleGoogleCallback = async (response: any) => {
    setLoading(true)
    setError('')
    try {
      const {data} = await googleSignIn(response.credential, aff || localStorage.getItem('aff') || '')
      if (data.success && data.api_token) {
        await finishGoogleLogin(data.api_token)
      } else {
        setError(data.error || 'שגיאה בהתחברות עם Google')
      }
    } catch (err: any) {
      saveAuth(undefined)
      setError(err?.response?.data?.error || 'שגיאה בהתחברות עם Google')
    } finally {
      setLoading(false)
    }
  }
  // Facebook sign-up — same flow as Google: account is created on the API, then the
  // profile gate asks for the phone.
  useEffect(() => {
    if (!FB_APP_ID || document.getElementById('facebook-jssdk')) return
    window.fbAsyncInit = function () {
      window.FB.init({appId: FB_APP_ID, cookie: true, xfbml: false, version: 'v19.0'})
    }
    const script = document.createElement('script')
    script.id = 'facebook-jssdk'
    script.src = 'https://connect.facebook.net/he_IL/sdk.js'
    script.async = true
    script.defer = true
    document.body.appendChild(script)
  }, [])
  const handleFacebookSignup = () => {
    setError('')
    if (!window.FB) return setError('פייסבוק עדיין נטען, נסו שוב בעוד רגע')
    setLoading(true)
    window.FB.login(
      async (response: any) => {
        try {
          if (response.status === 'connected' && response.authResponse?.accessToken) {
            const {data} = await facebookSignIn(response.authResponse.accessToken, aff || localStorage.getItem('aff') || '')
            if (data.success && data.api_token) await finishGoogleLogin(data.api_token)
            else setError(data.error || 'שגיאה בהרשמה עם פייסבוק')
          } else {
            setError('ההרשמה עם פייסבוק בוטלה')
          }
        } catch (err: any) {
          saveAuth(undefined)
          setError(err?.response?.data?.error || 'שגיאה בהרשמה עם פייסבוק')
        } finally {
          setLoading(false)
        }
      },
      {scope: 'email,public_profile'}
    )
  }

  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) return
    const script = document.createElement('script')
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    document.body.appendChild(script)
    script.onload = () => {
      if ((window as any).google) {
        ;(window as any).google.accounts.id.initialize({client_id: GOOGLE_CLIENT_ID, callback: handleGoogleCallback})
        const btn = document.getElementById('google-signup-button')
        if (btn) {
          ;(window as any).google.accounts.id.renderButton(btn, {theme: 'outline', size: 'large', width: '100%', text: 'signup_with', locale: 'he'})
        }
      }
    }
    return () => {
      const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]')
      if (existing) existing.remove()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aff])

  // Debounced agent autocomplete.
  useEffect(() => {
    if (agent) return // a pick is selected — don't keep searching
    if (searchTimer.current) clearTimeout(searchTimer.current)
    const q = agentQuery.trim()
    if (q.length < 2) {
      setResults([])
      return
    }
    searchTimer.current = setTimeout(async () => {
      setSearching(true)
      try {
        const res = await searchYad2Agents(q)
        setResults(res.data?.results || [])
        setShowResults(true)
      } catch (_) {
        setResults([])
      }
      setSearching(false)
    }, 300)
    return () => searchTimer.current && clearTimeout(searchTimer.current)
  }, [agentQuery, agent])

  const setField = (k: string, v: string) => setForm((f) => ({...f, [k]: v}))

  const pickAgent = (a: Yad2AgentRow) => {
    setAgent(a)
    setAgentQuery(a.name || a.phone)
    setShowResults(false)
  }
  const clearAgent = () => {
    setAgent(null)
    setAgentQuery('')
    setResults([])
  }

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    if (!form.yourname.trim()) return setError('יש להזין שם מלא')
    if (!form.phone.trim()) return setError('יש להזין מספר טלפון')
    // Must be a real Israeli MOBILE number: the account's login code, the connect link and
    // every support message go out by SMS/WhatsApp, so a landline, a foreign number or a
    // typo leaves an account nobody can reach — and it was previously accepted silently.
    const normalisedPhone = normaliseIlMobile(form.phone)
    if (!normalisedPhone) return setError('יש להזין מספר טלפון נייד ישראלי תקין (לדוגמה 050-1234567)')
    if (form.password.length < 4) return setError('יש לבחור סיסמה (לפחות 4 תווים)')
    if (withYad2 && !agent) return setError('יש לבחור את הסוכן שלך מתוך הרשימה')
    // Captcha is best-effort only — the widget is unreliable for some users, so we
    // don't block submitting when no token was produced. The token is still sent
    // when available and the server treats captcha as fail-open.

    setLoading(true)
    try {
      const {data} = await affiliateRegister({
        yourname: form.yourname.trim(),
        // Send the normalised 05XXXXXXXX form rather than whatever was typed, so accounts
        // don't end up stored with spaces, dashes, a +972 prefix or stray text around the
        // digits — all of which used to get through and then break number matching later.
        phone: normalisedPhone,
        email: form.email.trim(), // optional now — server derives one from the phone if blank
        password: form.password,
        aff,
        agent: withYad2 ? agent : null,
        turnstileToken,
      })
      if (!data?.success || !data.api_token) {
        setError(data?.message || 'ההרשמה נכשלה, נסו שוב')
        setLoading(false)
        return
      }
      // Show the post-register onboarding wizard once — ONLY for the plain
      // /auth/register flow (withYad2=false); the yad2-register flow already did
      // the agent import during signup.
      try { if (!withYad2) localStorage.setItem('onboarding_pending', '1') } catch (_) {}
      // Log the client straight into the app (same flow as the normal register).
      saveAuth({api_token: data.api_token})
      const {data: user} = await getUserByToken(data.api_token)
      trackRegistration(user)
      setCurrentUser(user)
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'ההרשמה נכשלה')
      setLoading(false)
    }
  }

  return (
    <form className='form w-100' onSubmit={submit} dir='rtl' style={{maxWidth: 480, margin: '0 auto'}}>
      {withYad2 ? (
        <div className='text-center mb-8'>
          <h1 className='text-dark fw-bolder mb-2'>הרשמה ל-FBZipper</h1>
          <div className='text-gray-500 fw-semibold fs-6'>
            מלאו את הפרטים ובחרו את הסוכן שלכם ביד2 — המערכת תפרסם את הנכסים שלכם אוטומטית.
          </div>
        </div>
      ) : (
        // Ads land here: say what FBZipper is before the form.
        <div className='text-center mb-8'>
          <h1 className='text-dark fw-bolder mb-1' style={{fontSize: 30}}>FBZipper</h1>
          <div className='fw-bold fs-3 mb-2' style={{color: '#1877F2'}}>
            פרסום אוטומטי בקבוצות פייסבוק ובמרקטפלייס
          </div>
          <div className='text-gray-600 fw-semibold fs-6 mb-3'>
            7 ימי ניסיון חינם, בלי כרטיס אשראי ובלי התחייבות
          </div>
          <a href='https://fbzipper.com' className='btn btn-sm btn-light-primary'>
            🏠 לדף הבית
          </a>
        </div>
      )}

      {error && (
        <div className='alert alert-danger d-flex align-items-center p-4 mb-6'>
          <span>{error}</span>
        </div>
      )}

      {/* One-click sign-up first (Google renders its own button). The profile gate then
          collects the phone. Ads land here, so the fewest steps win. */}
      <div id='google-signup-button' className='d-flex justify-content-center mb-3' onClick={(e) => e.preventDefault()} />
      {FB_APP_ID && (
        <button
          type='button'
          onClick={handleFacebookSignup}
          disabled={loading}
          className='btn btn-flex btn-outline w-100 d-flex align-items-center justify-content-center mb-5'
          style={{borderColor: '#1877F2', color: '#1877F2'}}
        >
          <svg width='20' height='20' viewBox='0 0 24 24' fill='#1877F2' className='me-2'>
            <path d='M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z' />
          </svg>
          הרשמה עם פייסבוק
        </button>
      )}
      <div className='d-flex align-items-center mb-5'>
        <div className='border-bottom border-gray-300 mw-50 w-100' />
        <span className='text-gray-500 fw-semibold fs-7 mx-3 text-nowrap'>או עם טלפון</span>
        <div className='border-bottom border-gray-300 mw-50 w-100' />
      </div>

      <div className='fv-row mb-5'>
        <label className='form-label fw-bold text-dark fs-6'>שם מלא</label>
        <input
          className='form-control bg-transparent'
          value={form.yourname}
          onChange={(e) => setField('yourname', e.target.value)}
          placeholder='ישראל ישראלי'
        />
      </div>

      <div className='fv-row mb-5'>
        <label className='form-label fw-bold text-dark fs-6'>טלפון</label>
        <input
          className='form-control bg-transparent'
          dir='ltr'
          type='tel'
          inputMode='tel'
          autoComplete='tel'
          value={form.phone}
          onChange={(e) => setField('phone', e.target.value)}
          placeholder='050-0000000'
        />
        {/* Only once they've typed enough to be wrong — nagging from the first keystroke
            flags every number as invalid while it's still being entered. */}
        {form.phone.replace(/\D/g, '').length >= 9 && !normaliseIlMobile(form.phone) && (
          <div className='text-danger fs-8 mt-1'>מספר טלפון נייד ישראלי בלבד (לדוגמה 050-1234567)</div>
        )}
      </div>

      <div className='fv-row mb-5'>
        <label className='form-label fw-bold text-dark fs-6'>סיסמה</label>
        <input
          type='password'
          className='form-control bg-transparent'
          value={form.password}
          onChange={(e) => setField('password', e.target.value)}
          placeholder='בחרו סיסמה'
        />
      </div>

      {/* yad2 agent picker */}
      {withYad2 && (
      <div className='fv-row mb-8' style={{position: 'relative'}}>
        <label className='form-label fw-bold text-dark fs-6'>הסוכן שלי ביד2</label>
        <div className='text-gray-600 fs-7 mb-3' style={{lineHeight: 1.6}}>
          חפשו את עצמכם במאגר הסוכנים של יד2 לפי <b>שם הסוכן</b>, <b>שם הסוכנות</b> או <b>מספר הטלפון הוירטואלי</b> שמופיע במודעות שלכם ביד2.
          לאחר הבחירה המערכת תייבא את כל הנכסים שלכם ותפרסם אותם אוטומטית בקבוצות פייסבוק.
        </div>
        {agent ? (
          <div className='d-flex align-items-center justify-content-between border rounded p-3' style={{background: '#f8fdf9', borderColor: '#34c759'}}>
            <div className='d-flex align-items-center gap-3' style={{minWidth: 0}}>
              {agent.avatar ? (
                <img src={agent.avatar} alt='' style={{width: 44, height: 44, borderRadius: '50%', objectFit: 'cover'}} />
              ) : (
                <div style={{width: 44, height: 44, borderRadius: '50%', background: '#eef', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <i className='bi bi-person' />
                </div>
              )}
              <div style={{minWidth: 0}}>
                <div className='fw-bold text-dark'>{agent.name}</div>
                {agent.agency_name && <div className='text-gray-600 fs-7 text-truncate'>{agent.agency_name}</div>}
                {agent.phone && <div className='text-gray-500 fs-8' dir='ltr' style={{textAlign: 'right'}}>{agent.phone}</div>}
                <span className='badge badge-light-success mt-1'>
                  <i className='bi bi-houses me-1' />
                  {agent.listings_count || 0} נכסים יתפרסמו
                </span>
              </div>
            </div>
            <button type='button' className='btn btn-sm btn-light-danger' onClick={clearAgent}>
              החלף
            </button>
          </div>
        ) : (
          <>
            <div style={{position: 'relative'}}>
              <i className='bi bi-search' style={{position: 'absolute', insetInlineStart: 12, top: '50%', transform: 'translateY(-50%)', color: '#aaa'}} />
              <input
                className='form-control bg-transparent'
                style={{paddingInlineStart: 36}}
                value={agentQuery}
                onChange={(e) => setAgentQuery(e.target.value)}
                onFocus={() => results.length && setShowResults(true)}
                placeholder='שם סוכן / שם סוכנות / טלפון וירטואלי…'
                autoComplete='off'
              />
            </div>
            {searching && <div className='text-gray-500 fs-8 mt-1'>מחפש במאגר יד2…</div>}
            {showResults && results.length > 0 && (
              <div
                className='bg-white border rounded shadow-sm'
                style={{position: 'absolute', top: '100%', insetInlineStart: 0, insetInlineEnd: 0, zIndex: 20, maxHeight: 320, overflowY: 'auto'}}
              >
                {results.map((a, i) => (
                  <div
                    key={a.broker_id || a.phone || i}
                    onClick={() => pickAgent(a)}
                    className='d-flex align-items-center gap-3 p-3'
                    style={{cursor: 'pointer', borderBottom: '1px solid #f1f1f1'}}
                  >
                    {a.avatar ? (
                      <img src={a.avatar} alt='' style={{width: 40, height: 40, borderRadius: '50%', objectFit: 'cover', flexShrink: 0}} />
                    ) : (
                      <div style={{width: 40, height: 40, borderRadius: '50%', background: '#eef', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0}}>
                        <i className='bi bi-person' />
                      </div>
                    )}
                    <div style={{flex: 1, minWidth: 0}}>
                      <div className='fw-bold text-dark text-truncate'>{a.name}</div>
                      {a.agency_name && <div className='text-gray-500 fs-7 text-truncate'>{a.agency_name}</div>}
                      {a.phone && <div className='text-gray-400 fs-8' dir='ltr' style={{textAlign: 'right'}}>{a.phone}</div>}
                    </div>
                    <span className='badge badge-light-primary' style={{flexShrink: 0}}>
                      {a.listings_count || 0} נכסים
                    </span>
                  </div>
                ))}
              </div>
            )}
            {showResults && !searching && agentQuery.trim().length >= 2 && results.length === 0 && (
              <div className='text-gray-500 fs-8 mt-1'>לא נמצאו סוכנים תואמים. נסו שם אחר או את הטלפון הוירטואלי מהמודעה ביד2.</div>
            )}
          </>
        )}
      </div>
      )}

      {TURNSTILE_ENABLED && (
        <TurnstileWidget
          onVerify={(t) => setTurnstileToken(t)}
          onExpire={() => setTurnstileToken('')}
          onError={() => setTurnstileToken('')}
        />
      )}

      {/* Never gated on the captcha token. Cloudflare's challenge fails outright for
          a slice of real visitors (error 600010 and friends), and disabling the button
          left them permanently unable to register — while the server has always
          treated the captcha as fail-open. The widget is signal, not a gate. */}
      <button type='submit' className='btn btn-primary w-100 mb-5' disabled={loading}>
        {loading ? <span className='spinner-border spinner-border-sm me-2' /> : null}
        {loading ? 'נרשם…' : 'הרשמה'}
      </button>

      <Link to='/auth/login'>
        <button type='button' className='btn btn-light-primary w-100'>
          כבר יש לי חשבון
        </button>
      </Link>
    </form>
  )
}

export default Yad2Register
